module.exports = __webpack_public_path__ + "img/gdzie_jest_vin.966f30ac.svg";